import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { ContactDetailsComponent } from "./contact/contact-details/contact-details.component";
import { ContactProfileComponent } from "./contact/contact-details/profile/contact-profile.component";
import { ContactWorkHistoryComponent } from "./contact/contact-details/workhistory/contact-work-history.component";
import { ContactWorkScheduleComponent } from "./contact/contact-details/workschedule/contact-work-schedule.component";
import { ContactWorkScheduleAllComponent } from "./contact/contact-details/workscheduleall/contact-work-schedule-all.component";
import { AuthGuardService } from "./core/services/auth-guard.service";
import { PendingChangesGuard } from "./core/services/pendingchanges-guard.service";
import { DashboardLayoutComponent } from "./dashboard/layout/dashboard-layout.component";
import { TemplateDetailsLayoutComponent } from "./dashboard/template-details/layout/template-details-layout.component";
import { BuTemplateListComponent } from "./dashboard/template/bu-template-list/bu-template-list.component";
import { CommonLayoutComponent } from "./shared/layout/common-layout.component";
import { TimesheetLayoutComponent } from "./timesheet/layout/timesheet-layout.component";

const routes: Routes = [
    {
        path: "",
        component: CommonLayoutComponent,
        data: {
            breadcrumb: "Home",
        },
        children: [
            {
                path: "",
                component: DashboardLayoutComponent,
                data: {
                    breadcrumb: "dashboard",
                },
            },
            {
                path: "dashboard",
                component: DashboardLayoutComponent,
                data: {
                    breadcrumb: "dashboard",
                },
            },
        ],
    },
    {
        path: "bu/:buid",
        component: CommonLayoutComponent,
        data: {
            breadcrumb: "Timesheet",
        },
        children: [
            {
                path: "",
                component: TimesheetLayoutComponent,
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: "Timesheet",
                    tokens: [
                        "ManageTimecards.Retrieve", //this route is accessible only to fin and payroll (tpm/bu/1)
                    ],
                },
            },
            {
                path: "batch/:batchid",
                component: TimesheetLayoutComponent,
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: "Timesheet",
                    tokens: [
                        "Timecard.Submitter.Save.Retrieve",
                        "Timecard.Approver.Save.Retrieve", //this route is accessible only to submitter/approver (tpm/bu/1/batch/8119)
                    ],
                },
            },
            {
                path: "wrfid/:wrfid",
                component: TimesheetLayoutComponent,
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: "Timesheet",
                    tokens: [
                        "ManageTimecards.Retrieve", //this route is accessible only to fin and payroll (tpm/bu/1/wrfid/4)
                    ],
                },
            },
            {
                path: "batch/:batchid/wrfid/:wrfid",
                component: TimesheetLayoutComponent,
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: "Timesheet",
                    tokens: [
                        "Timecard.Submitter.Save.Retrieve",
                        "Timecard.Approver.Save.Retrieve", //this route is accessible only to submitter/approver (tpm/bu/1/batch/8119/wrfid/5)
                    ],
                },
            },
        ],
    },
    {
        path: "bu/:buid/templates",
        component: CommonLayoutComponent,
        data: {
            breadcrumb: "Templates",
        },
        children: [
            {
                path: "",
                redirectTo: "list",
                pathMatch: "full",
            },
            {
                path: "list",
                component: BuTemplateListComponent,
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: "Templates",
                    tokens: [
                        "TPM.ManageTemplate.Retrieve", //route accessible only to submitter
                    ],
                },
            },
            {
                path: "list/:id/details",
                component: TemplateDetailsLayoutComponent,
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: "Template Details",
                    tokens: [
                        "TPM.ManageTemplate.Retrieve", //route accessible only to submitter
                    ],
                },
            },
        ],
    },

    {
        path: "contact/:id",
        component: CommonLayoutComponent,
        data: {
            breadcrumb: "Contact",
        },
        children: [
            {
                path: "" /*(lower case)*/,
                component: ContactDetailsComponent,
                data: {
                    breadcrumb: "Contact",
                },
                children: [
                    {
                        path: "",
                        redirectTo: "profileinfo",
                        pathMatch: "full",
                    },
                    {
                        path: "profileinfo",
                        component: ContactProfileComponent,
                        canActivate: [AuthGuardService],
                        data: {
                            tokens: [
                                "contact.retrieve",
                                "contact.hrmaster.retrieve",
                                "contact_profile_profile_info.retrieve",
                            ],
                        },
                    },
                    {
                        path: "workhistory",
                        component: ContactWorkHistoryComponent,
                        canActivate: [AuthGuardService],
                        data: {
                            tokens: [
                                "contact.workhistory.retrieve",
                                "contact_profile_work_history.retrieve",
                            ],
                        },
                    },
                    {
                        path: "workschedule",
                        component: ContactWorkScheduleComponent,
                        canActivate: [AuthGuardService],
                        data: {
                            tokens: [
                                "contact.workschedule.retrieve",
                                "contact.workschedule.create",
                                "contact_profile_work_schedule.retrieve",
                            ],
                        },
                    },
                    {
                        path: "workscheduleall",
                        component: ContactWorkScheduleAllComponent,
                        canActivate: [AuthGuardService],
                        data: {
                            tokens: [
                                "contact.workschedule.retrieve",
                                "contact.workschedule.create",
                                "contact_profile_work_schedule.retrieve",
                            ],
                        },
                    },
                ],
            },
        ],
    },
];

export const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: "always",
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routingConfiguration)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
